module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAP1BMVEVHcEz///////////////////////////////////////////////////////////////////////////////9KjZoYAAAAFHRSTlMAC79jP/QiAZvi8z79KB/7mbRApdLBj9cAAADNSURBVEjH7dTJFoMgEETRckgwJhqH/v9vjTgFlKHINrJqFncBp88DgKJT4E7ZZ+tUvKTiVHmTPNuMcGoysqjZUGo2i+pEOLUaebSAqji1m7u+cco2nDoaRp1NXLlMTLlNWPlMSPmNX4WMT4WNW8WMS8XNWTHmqDhjK9aYaqCNod68MVSCsRVrTMUbYFjfI6OizfbXbA8PRhLaK6lq34ORV9/dYStq7+jV3qu9/9xe9KntrRsgy9PaWz/1rBXf3sVoxbd3M5Nq6fY2+Pl8ABBrNkoo91SjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tbm/menu_close.png
// module id = W/T8
// module chunks = 40